export { default, getServerSideProps } from '~/pages/coordinate'
